var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3459_4593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.251953 15.6328L9.97266 25.9453C10.166 26.1504 10.4824 26.25 10.6934 26.25C10.9269 26.25 11.1614 26.1694 11.3473 26.0065C11.7441 25.6586 11.7735 25.0655 11.4128 24.6829L3.16992 15.9375H25.2779C25.8153 15.9375 26.25 15.5183 26.25 15.0527C26.25 14.5872 25.8152 14.0625 25.2779 14.0625H3.17051L11.4146 5.31445C11.7754 4.93178 11.746 4.33828 11.3491 3.99082C10.9513 3.64477 10.3372 3.67037 9.97512 4.05492L0.254416 14.3674C-0.0820312 14.7246 -0.0820312 15.2754 0.251953 15.6328Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3459_4593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 30,
    fill: "white",
    transform: "matrix(-1 0 0 1 26.25 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.920cba5b4f552aa63910b5b811eeb119.svg";
export { ForwardRef as ReactComponent };